import React from "react";
import ReactSwitch from "react-switch";

const Switch = (props) => <ReactSwitch height={20} width={50} uncheckedIcon={null} checkedIcon={null} {...props} />;
export default Switch;
